<template>
    <div class="col position-relative">
        <click-assistant
            class="w-100 bg-color cursor-pointer"
            @onceClick="$store.commit('calendarShift/setNeedScroll',true)"
            @doubleClick="$store.commit('calendarShift/setForceScroll',true)">

            <div class="d-flex flex-column h-100" style="width: 290px" v-if="operationId!==null && operationId!==''">
                <KeyValueCell horizontal :value="operationData.operationSeq">工序编号</KeyValueCell>
                <KeyValueCell horizontal :value="headCount">人数</KeyValueCell>
                <KeyValueCell horizontal :value="operationData.workHour+'H'">标准工时</KeyValueCell>
                <KeyValueCell horizontal :value="operationData.prdPpStatusName">工序状态</KeyValueCell>
                <KeyValueCell horizontal :value="missionMode">任务模式</KeyValueCell>
                <KeyValueCell horizontal :value="operationData.forecastBeginTime">计划开始</KeyValueCell>
                <KeyValueCell horizontal :value="operationData.forecastFinishTime">计划结束</KeyValueCell>
                <KeyValueCell horizontal :value="operationData.forecastMstLocationName">计划工作中心</KeyValueCell>
                <KeyValueCell horizontal :value="operationData.actualBeginTime">实际开始时间</KeyValueCell>
                <KeyValueCell :value="operationData.operationDescription" :length-limit="lengthLimit">工序描述
                </KeyValueCell>
            </div>
        </click-assistant>
        <avatar-button :icon="lengthLimit === -1 ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
                       class="position-absolute top right mr-1 mt-1"
                       v-if="operationId!==null && operationId!==''"
                       @btnClick="switchLengthLimit"></avatar-button>
    </div>
</template>

<script>
import KeyValueCell from "@/views/sithMes/prd/PrdOperationExcute/cells/KeyValueCell";
import ClickAssistant from "@/components/echarts-part/CalendarShift/cells/stuffs/ClickAssistant";
import AvatarButton from "@/components/echarts-part/CalendarShift/cells/stuffs/AvatarButton";

export default {
    name: "LoadRateOperationDetail",
    components: {AvatarButton, ClickAssistant, KeyValueCell},
    computed: {
        operationId() {
            return this.$store.state.calendarShift.selectedOperationId;
        },
        operationData() {
            return this.$store.getters["calendarShift/operationMap"][this.operationId];
        },
        headCount() {
            return this.operationData.headCount > 0 ? this.operationData.headCount + '位' : '无'
        },
        missionMode() {
            switch (this.operationData.missionMode) {
                case 1:
                case "1":
                    return '自动排产';
                case 2:
                case '2':
                    return '手动排产';
                default:
                    return '无'
            }
        }
    },
    data() {
        return {
            lengthLimit: 60
        }
    },
    methods: {
        switchLengthLimit() {
            if (this.lengthLimit !== -1) {
                this.lengthLimit = -1;
            } else {
                this.lengthLimit = 60;
            }
        }
    }
}
</script>

<style scoped>
.bg-color {
    background-color: #e6e6e6;
}

.bg-color:hover {
    background-color: #d3d3d5;;
}

.bg-color:active {
    background-color: #bdbec3;
}
</style>